/**
 * Created by nijin on 30/1/17.
 */
import { NgModule } from '@angular/core';
import {ConfirmationPopoverModule} from "angular-confirmation-popover";
import {ConfirmationPopover} from "angular-confirmation-popover/dist/esm/src/confirmationPopover.directive";

@NgModule({
    imports: [ConfirmationPopoverModule.forRoot({
      confirmButtonType: 'danger' // set defaults here

    })
    ],
    exports: [
      ConfirmationPopover
    ],
    declarations: [],
    providers: [],
})
export class ConfirmPopoverModule { }



// WEBPACK FOOTER //
// ./src/app/shared/confirmpopover/confirm.pop.module.ts